import { ref } from 'vue'

const DEFAULT_FALLBACK = 'An unexpected error occurred'

export function useAsyncAction() {
  const loading = ref(false)
  const error = ref<string | null>(null)

  async function execute<T>(
    fn: () => Promise<T>,
    errorFallback: string = DEFAULT_FALLBACK,
  ): Promise<T> {
    loading.value = true
    error.value = null
    try {
      return await fn()
    } catch (e: unknown) {
      error.value = e instanceof Error ? e.message : errorFallback
      throw e
    } finally {
      loading.value = false
    }
  }

  return { loading, error, execute }
}
